import Marquee from 'react-fast-marquee';
import { HStack, Text, theme, VStack } from 'ui_2';

const mintStrings: string[] = [
  'Downloading Amino Acids',
  'Photosynthesizing Sunlight',
  'Calibrating Watering Can',
  'Granting Free Will',
  'Decrypting Onchain Fertilizer',
  'Balancing Nutrient Coefficients',
  'Analyzing Squash Sentiments',
  'Tilling Virtual Soil',
  'Boosting Squash Confidence',
  'Rotating Virtual Crops',
  'Cultivating Squash Harmony',
  'Sprouting New Ideas',
  'Reaping Squash Rewards',
];

type Props = {
  active: boolean;
};

export const MintTextMarquee = ({ active }: Props) => {
  if (active === false) {
    return <VStack className='h-10 w-screen max-w-[478px]' />;
  }

  if (active) {
    return (
      <VStack className='flex h-10 max-w-[478px] items-center justify-center'>
        <Marquee
          className=' max-w-[478px]'
          gradient
          gradientWidth={16}
          speed={75}
          gradientColor={theme.colors.squashBg}
        >
          {mintStrings.map((text, ix) => (
            <HStack
              className='w-screen max-w-[478px] translate-x-[50vw]'
              key={ix}
            >
              <HStack className='flex-grow' />
              <Text>{text}...</Text>
            </HStack>
          ))}
        </Marquee>
      </VStack>
    );
  }
};
